<template>
  <v-footer app dark padless>
    <v-card flat dark tile class="indigo white--text text-center" width="100%">
      <v-card-text>
        <v-btn style="text-transform: none" text>
          <what-is-yokkame-compornent />
        </v-btn>
        <v-btn text>
          <terms-of-service-compornent />
        </v-btn>
        <v-btn v-for="icon in icons" :key="icon" class="mx-4 white--text" icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
        <v-btn disabled style="text-transform: none" text>
          {{ new Date().getFullYear() }}<strong>Yokkame</strong>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import TermsOfServiceCompornent from "../components/TermsOfService";
import WhatIsYokkameCompornent from "../components/WhatIsYokkame";

export default {
  components: {
    TermsOfServiceCompornent,
    WhatIsYokkameCompornent,
  },

  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
};
</script>
